import React from 'react';
import { showModal } from '../../../../styles/js/modals';

const RemoveFrom = ({ show, type }) => {
  if (!show) return null;

  return (
    <div className="mb-20 text__fs-16">
      <a
        href=""
        className="text-dark d-flex align-items-start"
        id="remove"
        data-dismiss="modal"
        onClick={(e) => {
          e.preventDefault();
          showModal('removeModal');
        }}
      >
        <img src="/img/bin.svg" alt="bin" className="mr-4 d-inline" />
        Remove from {type.from}
      </a>
    </div>
  );
};

export default RemoveFrom;
